var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImageTool = function SvgImageTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M27 6c1.65 0 3 1.35 3 3v16c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h18zm0 2H9c-.542 0-1 .458-1 1v16c0 .542.458 1 1 1h18c.542 0 1-.458 1-1V9c0-.542-.458-1-1-1zM10 23.799h16V17l-2.681-2.799a.688.688 0 0 0-.972 0L15.5 21.049l-2.264-2.264a.688.688 0 0 0-.972 0L10 21.049v2.75zm4.583-11.466a2.292 2.292 0 1 1-4.583 0 2.292 2.292 0 0 1 4.583 0z",
    fillRule: "evenodd"
  })));
};

export default SvgImageTool;